module.exports = __webpack_public_path__ + "img/slide-button-rechts.9f7f85870834962d885fd032a3de70c9.svg";